module.exports = __webpack_public_path__ + "static/media/BolitasAjonjoli.30b8ec69.jpg";